import NBType, { InferType } from '@netbase/nb-type'
import AnalysisType from '../enums/AnalysisType'
import NBColor from '../enums/NBColor'
import TimeInterval from '../enums/TimeInterval'

/**
 * @typedef {import('../enums/AnalysisType').AnalysisType} AnalysisType
 * @typedef {import('../enums/NBColor').NBColor} NBColor
 * @typedef {import('../enums/TimeInterval').TimeInterval} TimeInterval
 */

/**
 * @typedef {object} TimelineAnnotationSchema
 * @property {AnalysisType} analysisType
 * @property {NBColor} color
 * @property {string} description
 * @property {number} endDatetime
 * @property {number} groupId
 * @property {number} id
 * @property {string} owner
 * @property {number} startDatetime
 * @property {TimeInterval} timeInterval
 */
const TimelineAnnotationSchema = NBType.object().shape('TimelineAnnotationSchema', {
  /* @prop */
  analysisType: NBType.enum(AnalysisType),
  /* @prop */
  color: NBType.enum(NBColor),
  /* @prop */
  description: NBType.string(),
  /* @prop */
  endDatetime: NBType.number(),
  /* @prop */
  groupId: NBType.number(),
  /* @prop */
  id: NBType.number(),
  /* @prop */
  owner: NBType.string(),
  /* @prop */
  startDatetime: NBType.number(),
  /* @prop */
  timeInterval: NBType.enum(TimeInterval)
  /* END */
})
export default TimelineAnnotationSchema
// RESERVE BELOW
export type TimelineAnnotation = InferType<typeof TimelineAnnotationSchema>
